import config from '../config.json';
import { env } from '../env';

export interface ClientConfig {
    APPLICATION_NAME: string;
    CLIENT_INSTANCE: string;
    PLATFORM_NAME: string;
    DEFAULT_LOGO: string;
    DEFAULT_TITLE: string;
    CHAT_ENABLED: boolean;
    HELP_EMAIL_ADDRESS: string;
    DOMAIN_NAME: string;
    GOOGLE_TAG_MANAGER_ID: string;
    APP_INSIGHTS_VARIABLE_NAME: string;
    CONTENT: Content;
}

export interface RegisteredPage {
    PageName: string;
}

export interface Content {
    EV_ADVISOR_NAME: string;
    FLEET_ASSESSMENT_SERVICES_NAME: string;
    EV_INSTALLATION_CHECKLIST_BODY: string;
    EV_INSTALLATION_CHECKLIST_LINK: string;
    FOOTER_LINKS: Link[],
    WHY_SWITCH_BUTTON: string;
    INSTANT_ESTIMATE_BUTTON: string;
    REGISTERED_USERS_PAGES: RegisteredPage[];
}

export interface Link {
    TITLE: string,
    URL: string
}

const currentDomain = window.location.hostname.toLowerCase();
var selectedClientName : string | undefined = env.REACT_APP_CLIENTAPPLICATIONINSTANCE;

// Try to retrieve the configuration from sessionStorage, use currentDomain as key
const cachedConfigString = sessionStorage.getItem(currentDomain);
var cachedConfig: ClientConfig | null = cachedConfigString
    ? JSON.parse(cachedConfigString)
    : null;

let desiredClient: any | null = null;

if (!cachedConfig) {

    if (selectedClientName === undefined) {
        console.log('env.REACT_APP_CLIENTAPPLICATIONINSTANCE is undefined. Use domain to look up.')

        //Compare any one of the there fields matched DOMAIN_NAME|CLIENT_INSTANCE|APPLICATION_NAME
        const matchingClient = config.Clients.find(client =>
            currentDomain.includes(client.DOMAIN_NAME.toLowerCase()) ||
            currentDomain.includes(client.CLIENT_INSTANCE.toLowerCase()) ||
            currentDomain.includes(client.APPLICATION_NAME.toLowerCase())
        );

        selectedClientName = matchingClient?.APPLICATION_NAME || 'ICFDemo'; //Default to ICFDemo
    }

    desiredClient = config.Clients.find(
        (client) => client.APPLICATION_NAME === selectedClientName
    );

    if (desiredClient) {
        //Save to session storage using currentDomain as key
        sessionStorage.setItem(currentDomain, JSON.stringify(desiredClient));

    }
    else {
        console.error('Cannot read config.json with APPLICATION_NAME =[' + selectedClientName + '].')
    }
}

// Use the cached configuration or the one fetched from config.json
export const clientConfig: ClientConfig | null = cachedConfig || desiredClient || null;